import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { useDateFormatPreference } from '@witmetrics/data-store';
import { formatTextDate } from '@witmetrics/utils/time';
import { useToggle } from '@/hooks/useToggle';
import DefaultOptionsMenu from '@/components/DefaultOptionsMenu';
import { OptionsIcon } from '@/icons';
import { classes } from './utils';

export type KeypointHeaderProps = {
  deletable?: boolean;
  editable?: boolean;
  className?: string;
  title: string;
  timestamp: string;
  onEdit: () => void;
  onDelete: () => void;
};

export default function KeypointHeader({
  deletable,
  editable,
  className,
  title,
  timestamp,
  onEdit,
  onDelete,
}: KeypointHeaderProps) {
  const menuToggleRef = useRef(null);
  const dateFormat = useDateFormatPreference();
  const [isMenuOpen, toggleMenu] = useToggle();

  return (
    <div className={twMerge(classes.wrapper, className)}>
      <div>
        <span className={classes.title}>{title}</span>
        <span className={classes.timestamp}>
          {formatTextDate(timestamp, dateFormat)}
        </span>
      </div>
      {deletable && (
        <div className={classes.optionsWrapper}>
          <OptionsIcon
            ref={menuToggleRef}
            className={classes.optionsIcon}
            onClick={() => toggleMenu()}
          />
          {isMenuOpen && (
            <DefaultOptionsMenu
              anchorTo={menuToggleRef.current}
              open
              onEdit={editable ? onEdit : undefined}
              onDelete={onDelete}
              onClose={() => toggleMenu(false)}
            />
          )}
        </div>
      )}
    </div>
  );
}
